import {ChangeDetectorRef, Component, EventEmitter, Input, Output, QueryList, ViewChildren} from "@angular/core";
import {List} from "immutable";
import {StoreModel} from "../../models/StoreModel";
import * as _ from "lodash";

@Component({
    selector: 'td[simpleGridDataChecks]',
    styles: [`
        i {
            cursor: pointer;
        }

        .slideMode {
            padding-top: 8px;
            padding-right: 20px;
        }
    `],
    template: `
        @if (!slideMode) {
          <div>
            @for (item of m_checkboxes; track item) {
              <div>
                <label class="pull-left">{{item.name}}</label>
                <input (click)="onClick()" #checkInputs type="checkbox" [checked]="item" value="{{item}}" class="pull-left" style="margin-right: 2px">
              </div>
            }
          </div>
        }
        @if (slideMode) {
          <div class="slideMode">
            @for (item of m_checkboxes; track item) {
              <div class="material-switch pull-right">
                <input id="{{m_checkId}}" (mouseup)="onClick()" (click)="onClick()" #checkInputs type="checkbox" [checked]="item" value="{{item}}" class="pull-left" style="margin-right: 2px">
                <label [attr.for]="m_checkId" class="label-primary"></label>
              </div>
            }
          </div>
        }
        `
})
export class SimpleGridDataChecksComponent {
    constructor(public cdr: ChangeDetectorRef) {}

    m_checkId = _.uniqueId('slideCheck');
    m_checkboxes: Array<any>;
    m_storeModel: StoreModel;

    @ViewChildren('checkInputs')
    inputs: QueryList<any>;

    @Input()
    set checkboxes(i_checkboxes: Array<any>) {
        this.m_checkboxes = i_checkboxes;
    }

    @Input()
    set item(i_storeModel: StoreModel | any) {
        this.m_storeModel = i_storeModel;
    }

    @Input()
    slideMode = false;

    @Output()
    changed: EventEmitter<any> = new EventEmitter();

    public onClick() {
        const values = [];
        this.inputs.map(v => {
            values.push(v.nativeElement.checked);
        });
        this.changed.emit({item: this.m_storeModel, value: values});
        return true;
    }
}

